import axiosBasicInstance from '../axiosConfig';

const getVersionDeploying = async () => {
   try {
      const response = await axiosBasicInstance.get(`/management/getVersionDeploying`);
      return response;
   } catch (error) {
      throw error;
   }
};

export { getVersionDeploying};
